import React, { useEffect, useState } from "react";
import StaffManagement from "./_components/StaffManagement";
import MerchantManagement from "./_components/MerchantManagement";
import DriversManagement from "./_components/DriversManagement";
import OutSourceManagement from "./_components/OutSourceManagement";
import AccessControlManagement from "./_components/AccessControlManagement";
import ClientsManagement from "./_components/ClientsManagement";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../components/PermissionTabManager";

import ViewStaffModal from "./_components/ViewStaffModal";
import AddStaffSidebar from "./_components/AddStaffSidebar";
import StaffBulkUploadModals from "./_components/StaffBulkUploadModals";
import StaffBulkResponseModals from "./_components/StaffBulkResponseModals";
import ViewMerchantModal from "./_components/ViewMerchantModal";
import ManagePickupLocationsModal from "./_components/ManagePickupLocationsModal";
import MerchantBulkUploadModals from "./_components/MerchantBulkUploadModals";
import MerchantBulkResponseModals from "./_components/MerchantBulkResponseModals";
import AddMerchantSidebar from "./_components/AddMerchantSidebar";
import AddMerchantLinkSidebar from "./_components/AddMerchantLinkSidebar";
import AddMerchantCreateRequestSidebar from "./_components/AddMerchantCreateRequestSidebar";
import DriverBulkUploadModals from "./_components/DriverBulkUploadModals";
import DriverBulkResponseModals from "./_components/DriverBulkResponseModals";
import OutSourceBulkUploadModals from "./_components/OutSourceBulkUploadModals";
import OutsourceBulkResponseModals from "./_components/OutsourceBulkResponseModals";
import AddDriverSidebar from "./_components/AddDriverSidebar";
import AddOutSourceSidebar from "./_components/AddOutSourceSidebar";
import ViewDriverModal from "./_components/ViewDriverModal";
import ViewOutSourceModal from "./_components/ViewOutSourceModal";

const ALL_TABS = [
  {
    key: "Staff",
    label: "Staff",
    component: <StaffManagement />,
    modules: ["staffs"],
    operation: "read",
  },
  {
    key: "Merchant",
    label: "Merchant",
    component: <MerchantManagement />,
    modules: ["clients"],
    operation: "read",
  },
  {
    key: "Drivers",
    label: "Drivers",
    component: <DriversManagement />,
    modules: ["drivers"],
    operation: "read",
  },
  {
    key: "Out Source",
    label: "Out Source",
    component: <OutSourceManagement />,
    modules: ["out_source"],
    operation: "read",
  },
  {
    key: "Access Control",
    label: "Access Control",
    component: <AccessControlManagement />,
    modules: ["access_center"],
    operation: "read",
  },
  {
    key: "Requests",
    label: "Requests",
    component: <ClientsManagement />,
    modules: ["client_request"],
    operation: "read",
  },
];

type RightPanelType =
  | "viewStaff"
  | "addStaff"
  | "bulkUpload"
  | "bulkResponse"
  | "viewMerchant"
  | "managePickupLocations"
  | "addMerchant"
  | "addMerchantLink"
  | "addMerchantCreate"
  | "merchantBulkUpload"
  | "merchantBulkResponse"
  | "driverBulkUpload"
  | "driverBulkResponse"
  | "outSourceBulkUpload"
  | "outSourceBulkResponse"
  | "addDriver"
  | "addOutSource"
  | "viewDriver"
  | "viewOutSource"
  | null;
type PanelState = {
  tab: string;
  type: RightPanelType;
} | null;

const Users: React.FC = () => {
  const result = usePermissionTabs({ tabs: ALL_TABS, param: "tab" });

  const [panelState, setPanelState] = useState<PanelState>(null);
  const [headerActions, setHeaderActions] = useState<React.ReactNode>(null);
  const [headerButtons, setHeaderButtons] = useState<React.ReactNode>(null);

  const [selectedMerchantId, setSelectedMerchantId] = useState<string | null>(
    null,
  );

  const [selectedMerchantData, setSelectedMerchantData] = useState<any>(null);

  const [merchantBulkResponse, setMerchantBulkResponse] = useState<any>(null);

  const [selectedRequestId, setSelectedRequestId] = useState<string | null>(null);
  const [selectedRequest, setSelectedRequest] = useState<any>(null);

  const [selectedStaffId, setSelectedStaffId] = useState<string | null>(null);

  const [staffBulkResponse, setStaffBulkResponse] = useState<any>(null);

  const [driverBulkResponse, setDriverBulkResponse] = useState<any>(null);

  const [outSourceBulkResponse, setOutSourceBulkResponse] = useState<any>(null);

  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);

  const [selectedOutSourceId, setSelectedOutSourceId] = useState<string | null>(
    null,
  );

  useEffect(() => {
    const handleAddMerchantLink = (e: any) => {
      setSelectedRequestId(e.detail.id);
      setPanelState({
        tab: "Requests",
        type: "addMerchantLink",
      });
    };

    const handleAddMerchantCreate = (e: any) => {
      setSelectedRequest(e.detail.request);
      setPanelState({
        tab: "Requests",
        type: "addMerchantCreate",
      });
    };

    const handleViewStaff = (e: any) => {
      setSelectedStaffId(e.detail.staffId);

      setPanelState({
        tab: "Staff",
        type: "viewStaff",
      });
    };

    const handleAddStaff = () => {
      setPanelState({
        tab: "Staff",
        type: "addStaff",
      });
    };

    const handleBulkUpload = () => {
      setPanelState({
        tab: "Staff",
        type: "bulkUpload",
      });
    };

    const handleBulkResponse = (e: any) => {
      setStaffBulkResponse(e.detail.data);

      setPanelState({
        tab: "Staff",
        type: "bulkResponse",
      });
    };

    const handleViewMerchant = (e: any) => {
      setSelectedMerchantId(e.detail.id);

      setPanelState({
        tab: "Merchant",
        type: "viewMerchant",
      });
    };

    const handleManagePickupLocations = (e: any) => {
      setSelectedMerchantData(e.detail.merchant);

      setPanelState({
        tab: "Merchant",
        type: "managePickupLocations",
      });
    };

    const handleAddMerchant = () => {
      setPanelState({
        tab: "Merchant",
        type: "addMerchant",
      });
    };

    const handleMerchantBulkUpload = () => {
      setPanelState({
        tab: "Merchant",
        type: "merchantBulkUpload",
      });
    };

    const handleMerchantBulkResponse = (e: any) => {
      setMerchantBulkResponse(e.detail.data);

      setPanelState({
        tab: "Merchant",
        type: "merchantBulkResponse",
      });
    };

    const handleDriverBulkUpload = () => {
      setPanelState({
        tab: "Drivers",
        type: "driverBulkUpload",
      });
    };

    const handleDriverBulkResponse = (e: any) => {
      setDriverBulkResponse(e.detail.data);

      setPanelState({
        tab: "Drivers",
        type: "driverBulkResponse",
      });
    };

    const handleOutSourceBulkUpload = () => {
      setPanelState({
        tab: "Out Source",
        type: "outSourceBulkUpload",
      });
    };

    const handleOutSourceBulkResponse = (e: any) => {
      setOutSourceBulkResponse(e.detail.data);

      setPanelState({
        tab: "Out Source",
        type: "outSourceBulkResponse",
      });
    };

    const handleAddDriver = () => {
      setPanelState({
        tab: "Drivers",
        type: "addDriver",
      });
    };

    const handleAddOutSource = () => {
      setPanelState({
        tab: "Out Source",
        type: "addOutSource",
      });
    };

    const handleViewDriver = (e: any) => {
      setSelectedDriverId(e.detail.driverId);

      setPanelState({
        tab: "Drivers",
        type: "viewDriver",
      });
    };

    const handleViewOutSource = (e: any) => {
      setSelectedOutSourceId(e.detail.outSourceId);

      setPanelState({
        tab: "Out Source",
        type: "viewOutSource",
      });
    };

    // Requests
    window.addEventListener(
      "openAddMerchantLink",
      handleAddMerchantLink as EventListener,
    );
    window.addEventListener(
      "openAddMerchantCreate",
      handleAddMerchantCreate as EventListener,
    );

    // Staff
    window.addEventListener("openStaffModal", handleViewStaff as EventListener);

    window.addEventListener(
      "openAddStaffModal",
      handleAddStaff as EventListener,
    );

    window.addEventListener(
      "openBulkUploadModal",
      handleBulkUpload as EventListener,
    );

    window.addEventListener(
      "openBulkResponseModal",
      handleBulkResponse as EventListener,
    );

    // Merchant
    window.addEventListener(
      "openMerchantModal",
      handleViewMerchant as EventListener,
    );

    window.addEventListener(
      "openManagePickupLocationsModal",
      handleManagePickupLocations as EventListener,
    );

    window.addEventListener(
      "openAddMerchantModal",
      handleAddMerchant as EventListener,
    );

    window.addEventListener(
      "openMerchantBulkUploadModal",
      handleMerchantBulkUpload as EventListener,
    );

    window.addEventListener(
      "openMerchantBulkResponseModal",
      handleMerchantBulkResponse as EventListener,
    );

    // Drivers
    window.addEventListener(
      "openDriverBulkUploadModal",
      handleDriverBulkUpload as EventListener,
    );

    window.addEventListener(
      "openDriverBulkResponseModal",
      handleDriverBulkResponse as EventListener,
    );

    window.addEventListener(
      "openAddDriverModal",
      handleAddDriver as EventListener,
    );

    window.addEventListener(
      "openDriverModal",
      handleViewDriver as EventListener,
    );

    // Out Source
    window.addEventListener(
      "openOutSourceBulkUploadModal",
      handleOutSourceBulkUpload as EventListener,
    );

    window.addEventListener(
      "openOutSourceBulkResponseModal",
      handleOutSourceBulkResponse as EventListener,
    );

    window.addEventListener(
      "openAddOutSourceModal",
      handleAddOutSource as EventListener,
    );

    window.addEventListener(
      "openOutSourceModal",
      handleViewOutSource as EventListener,
    );

    return () => {
      // Requests cleanup
      window.removeEventListener(
        "openAddMerchantLink",
        handleAddMerchantLink as EventListener,
      );
      window.removeEventListener(
        "openAddMerchantCreate",
        handleAddMerchantCreate as EventListener,
      );

      // Staff cleanup
      window.removeEventListener(
        "openStaffModal",
        handleViewStaff as EventListener,
      );

      window.removeEventListener(
        "openAddStaffModal",
        handleAddStaff as EventListener,
      );

      window.removeEventListener(
        "openBulkUploadModal",
        handleBulkUpload as EventListener,
      );

      window.removeEventListener(
        "openBulkResponseModal",
        handleBulkResponse as EventListener,
      );

      // Merchant cleanup
      window.removeEventListener(
        "openMerchantModal",
        handleViewMerchant as EventListener,
      );

      window.removeEventListener(
        "openManagePickupLocationsModal",
        handleManagePickupLocations as EventListener,
      );

      window.removeEventListener(
        "openAddMerchantModal",
        handleAddMerchant as EventListener,
      );

      window.removeEventListener(
        "openMerchantBulkUploadModal",
        handleMerchantBulkUpload as EventListener,
      );

      window.removeEventListener(
        "openMerchantBulkResponseModal",
        handleMerchantBulkResponse as EventListener,
      );

      // Drivers cleanup
      window.removeEventListener(
        "openDriverBulkUploadModal",
        handleDriverBulkUpload as EventListener,
      );

      window.removeEventListener(
        "openDriverBulkResponseModal",
        handleDriverBulkResponse as EventListener,
      );

      window.removeEventListener(
        "openAddDriverModal",
        handleAddDriver as EventListener,
      );

      window.removeEventListener(
        "openDriverModal",
        handleViewDriver as EventListener,
      );

      // Out Source cleanup
      window.removeEventListener(
        "openOutSourceBulkUploadModal",
        handleOutSourceBulkUpload as EventListener,
      );

      window.removeEventListener(
        "openOutSourceBulkResponseModal",
        handleOutSourceBulkResponse as EventListener,
      );

      window.removeEventListener(
        "openAddOutSourceModal",
        handleAddOutSource as EventListener,
      );

      window.removeEventListener(
        "openOutSourceModal",
        handleViewOutSource as EventListener,
      );
    };
  }, []);

  const showRightPanel = !!panelState && panelState.tab === result.activeLabel;

  // Clone active tab content with header-injection callbacks
  const clonedContent =
    result.content && React.isValidElement(result.content)
      ? React.cloneElement(
          result.content as React.ReactElement,
          {
            setHeaderActions,
            setHeaderButtons,
          } as any,
        )
      : result.content;

  // Right panel — all sidebar/modal variants in one conditional block
  const rightPanel = (
    <div className="col-span-12 lg:col-span-5 space-y-4">
      {panelState?.type === "viewStaff" && selectedStaffId && (
        <ViewStaffModal
          staffId={selectedStaffId}
          open
          onClose={() => {
            setSelectedStaffId(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "addStaff" && (
        <AddStaffSidebar onClose={() => setPanelState(null)} />
      )}

      {panelState?.type === "bulkUpload" && (
        <StaffBulkUploadModals
          onClose={() => setPanelState(null)}
          onResponseOpene={() => {}}
          setStaffBulkResponse={(data: any) => {
            setStaffBulkResponse(data);
            window.dispatchEvent(
              new CustomEvent("openBulkResponseModal", { detail: { data } }),
            );
          }}
        />
      )}

      {panelState?.type === "bulkResponse" && staffBulkResponse && (
        <StaffBulkResponseModals
          data={staffBulkResponse}
          onClose={() => {
            setStaffBulkResponse(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "viewMerchant" && selectedMerchantId && (
        <ViewMerchantModal
          id={selectedMerchantId}
          open
          refetchList={() => {}}
          onClose={() => {
            setSelectedMerchantId(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "managePickupLocations" && selectedMerchantData && (
        <ManagePickupLocationsModal
          merchant={selectedMerchantData}
          open
          onClose={() => {
            setSelectedMerchantData(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "addMerchant" && (
        <AddMerchantSidebar onClose={() => setPanelState(null)} />
      )}

      {panelState?.type === "addMerchantLink" && selectedRequestId !== null && (
        <AddMerchantLinkSidebar
          id={selectedRequestId}
          onClose={() => {
            setSelectedRequestId(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "addMerchantCreate" && selectedRequest && (
        <AddMerchantCreateRequestSidebar
          request={selectedRequest}
          onClose={() => {
            setSelectedRequest(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "merchantBulkUpload" && (
        <MerchantBulkUploadModals
          onClose={() => setPanelState(null)}
          onResponseOpene={() => {}}
          setStaffBulkResponse={(data: any) => {
            setMerchantBulkResponse(data);
            window.dispatchEvent(
              new CustomEvent("openMerchantBulkResponseModal", {
                detail: { data },
              }),
            );
          }}
        />
      )}

      {panelState?.type === "merchantBulkResponse" && merchantBulkResponse && (
        <MerchantBulkResponseModals
          data={merchantBulkResponse}
          onClose={() => {
            setMerchantBulkResponse(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "driverBulkUpload" && (
        <DriverBulkUploadModals
          onClose={() => setPanelState(null)}
          onResponseOpene={() => {}}
          setDriverBulkResponse={(data: any) => {
            setDriverBulkResponse(data);
            window.dispatchEvent(
              new CustomEvent("openDriverBulkResponseModal", {
                detail: { data },
              }),
            );
          }}
        />
      )}

      {panelState?.type === "driverBulkResponse" && driverBulkResponse && (
        <DriverBulkResponseModals
          data={driverBulkResponse}
          onClose={() => {
            setDriverBulkResponse(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "outSourceBulkUpload" && (
        <OutSourceBulkUploadModals
          onClose={() => setPanelState(null)}
          onResponseOpene={() => {}}
          setStaffBulkResponse={(data: any) => {
            setOutSourceBulkResponse(data);
            window.dispatchEvent(
              new CustomEvent("openOutSourceBulkResponseModal", {
                detail: { data },
              }),
            );
          }}
        />
      )}

      {panelState?.type === "outSourceBulkResponse" &&
        outSourceBulkResponse && (
          <OutsourceBulkResponseModals
            data={outSourceBulkResponse}
            onClose={() => {
              setOutSourceBulkResponse(null);
              setPanelState(null);
            }}
          />
        )}

      {panelState?.type === "addDriver" && (
        <AddDriverSidebar onClose={() => setPanelState(null)} />
      )}

      {panelState?.type === "addOutSource" && (
        <AddOutSourceSidebar onClose={() => setPanelState(null)} />
      )}

      {panelState?.type === "viewDriver" && selectedDriverId && (
        <ViewDriverModal
          id={selectedDriverId}
          open
          onClose={() => {
            setSelectedDriverId(null);
            setPanelState(null);
          }}
        />
      )}

      {panelState?.type === "viewOutSource" && selectedOutSourceId && (
        <ViewOutSourceModal
          id={selectedOutSourceId}
          open
          onClose={() => {
            setSelectedOutSourceId(null);
            setPanelState(null);
          }}
        />
      )}
    </div>
  );

  return (
    <PermissionTabManager
      visibleTabs={result.visibleTabs}
      activeLabel={result.activeLabel ?? ""}
      content={clonedContent}
      isLoading={result.isLoading}
      error={result.error}
      handleChange={result.handleChange}
      // Outer wrapper — mirrors the original `px-6 space-y-6 pb-8`
      className="px-6 space-y-6 pb-8"
      subClassName="space-y-0"
      // Content div inside the grid has no extra classes
      contentClassName=""
      activeClassName="bg-[#000000] text-[#ffffff] font-bold shadow-sm"
      // Action buttons injected by child tabs (setHeaderActions / setHeaderButtons)
      headerButtons={
        <div className="flex items-center gap-2">
          {headerActions}
          {headerButtons}
        </div>
      }
      // Grid that wraps content + right panel — mirrors original bg/padding/rounded
      contentGridClassName="gap-6 p-3 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-r-3xl rounded-bl-3xl w-full"
      rightPanel={rightPanel}
      showRightPanel={showRightPanel}
    />
  );
};

export default Users;
